import { render } from "./AffirmFailed.vue?vue&type=template&id=2826a36f&scoped=true&ts=true&lang=pug"
import script from "./AffirmFailed.vue?vue&type=script&setup=true&lang=ts"
export * from "./AffirmFailed.vue?vue&type=script&setup=true&lang=ts"

import "./AffirmFailed.vue?vue&type=style&index=0&id=2826a36f&scoped=true&lang=stylus"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2826a36f"]])

export default __exports__